// Thời gian ISR/revalidate mặc định (giây) dùng chung cho MỌI fetch nội dung Strapi.
// Freshness thực tế do stale-watermark của Redis điều khiển (xem cache-handler.js),
// nên giá trị này chỉ là trần fallback theo thời gian. Đổi 1 chỗ → áp dụng toàn bộ.
export const REVALIDATE_TIME = 10800 // 3h
